import React from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../components/containers/AdaptiveContainer';
import ProfilePasswordComponent from '../../components/page-components/profile/ProfilePasswordComponent';

const ProfilePassword = () => {
    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer>
                    <ProfilePasswordComponent />
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default ProfilePassword;
